import { Component, Inject, NgZone, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ActivatedRoute, Router } from '@angular/router';
import { Auth } from 'aws-amplify';
import { ConstantsService } from '../services/constants.service';
import { CacheService } from '../services/cache.service';
import { AdminService } from '../services/admin.service';
import { GetPaymentService } from '../services/get-payment.service';
import { MatDialog } from '@angular/material/dialog';
import { DOCUMENT } from '@angular/common';
import { SpinnerService } from '../services/spinner.service';
import { UserService } from '../services/user.service';
import { environment } from 'src/environments/environment';
import { SharedMixpanelService } from '../services/shared-mixpanel.service';
import { SessionService } from '../services/session.service';
import { Subscription } from 'rxjs';
// import { HelperService } from '../services/helper.service';
@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
})
export class UserProfileComponent implements OnInit, AfterViewInit, OnDestroy {
  public userName = '';
  public FirstName = '';
  public SecondName = '';
  public isBookmark = true;
  public isMyVideo = null;
  public isTipJar = null;
  public profilePicture = '';
  public isLoading = true;
  public memberskelload = true;
  public memberId = '';
  public userId = '';
  public isAdmin: any;
  public from = '';
  public isPrimeLoading = false;
  public isPrime: any;
  isLogin: boolean;
  public isRemoving = false;
  showconfirmModal: boolean = false;
  userEmail: any;
  subscriptionID: any;
  private subscription1: Subscription;
  private subscription2: Subscription;
  public isMobile;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    public constants: ConstantsService,
    private zone: NgZone,
    private route: ActivatedRoute,
    private cache: CacheService,
    private adminservice: AdminService,
    private spinner: SpinnerService,
    private router: Router,
    private get_payment: GetPaymentService,
    public dialog: MatDialog,
    public userService: UserService,
    private mixpanel: SharedMixpanelService,
    private sessionService: SessionService,
    // private helperService: HelperService,
    public deviceService: DeviceDetectorService,
  ) { 
    this.isMobile = this.deviceService.isMobile();
   }
  bookmark() {
    this.isBookmark = true;
    this.isMyVideo = false;
    this.isTipJar = false;
    this.router.navigate(['user']), { relativeTo: this.route };
  }
  myVideo() {
    this.isMyVideo = true;
    this.isBookmark = false;
    this.isTipJar = false;
    this.router.navigate(['user/mywindow']), { relativeTo: this.route };
  }
  YourTipJar() {
    this.isTipJar = true;
    this.isMyVideo = false;
    this.isBookmark = false;
    this.router.navigate(['user/tipjar']), { relativeTo: this.route };
  }
  ngOnInit(): void {
    this.subscription1 = this.adminservice.creatorObservable.subscribe((data) => {
      if (data !== undefined) {
        if (data.hasOwnProperty("profilePicture")) {
          this.profilePicture = data.profilePicture;
        }
        if (data.hasOwnProperty("memberId")) {
          this.memberId = data.memberId;
        }
        if (data.hasOwnProperty("first_name")) {
          this.userName = data.first_name;
        }
      }
    }, (err) => {
      console.log(err);
    })
    this.subscription2 = this.adminservice.hideSkeletonForUserProfileObservable.subscribe((data) => {
      if (data) {
        this.hideSkeleton();
      }
    }, (err) => {
      console.log(err);
    })
    let userDetails = this.adminservice.getSharedUserData();
    let authorObj = this.sessionService.getItem('authorObj');
    if (authorObj) {
      let profilePicture = this.constants.AVATAR_IMG;
        this.userName=authorObj.name;
        this.memberId= "NA";
        this.profilePicture= profilePicture;
        this.memberskelload = true
        this.isLoading = false;
    }
    if (userDetails !== undefined) {
      let profilePicture = this.constants.AVATAR_IMG;
      let currentUrl = document.URL.split('/');
      this.from = currentUrl.slice(3).toLocaleString().toLowerCase();
      if (this.from === 'user,mywindow') {
        this.isMyVideo = true;
        this.isBookmark = false;
      } else {
        this.isBookmark = true;
        this.isMyVideo = false;
      }
      this.cache.animateUI('easeinout');
      this.userName = userDetails.name;
      this.profilePicture = profilePicture;
      this.memberId = "NA";
      this.memberskelload = false
      this.isLoading = false;
    } else {
      let currentUrl = document.URL.split('/');
      this.from = currentUrl.slice(3).toLocaleString().toLowerCase();
      if (this.from === 'user,mywindow') {
        this.isMyVideo = true;
        this.isBookmark = false;
      } else if (this.from === 'user,tipjar') {
        this.isTipJar = true;
        this.isMyVideo = false;
        this.isBookmark = false;
      } else if (this.from === 'user,return') {
        this.isTipJar = true;
        this.isMyVideo = false;
        this.isBookmark = false;
      } else if (this.from === 'user,reauth') {
        this.isTipJar = true;
        this.isMyVideo = false;
        this.isBookmark = false;
      } else {
        this.isBookmark = true;
        this.isMyVideo = false;
      }
      this.cache.animateUI('easeinout');
      if(!authorObj) {
      this.isLoading = true;
      this.authcall();
      }
    }
  }

  ngAfterViewInit(): void {
    // The section below is commented out because Publift ads need to be removed.
    // if (!this.isPrime) {
    //   const fusetag = window['fusetag'] || (window['fusetag'] = { que: [] });
    //   fusetag.que.push(function () {
    //     fusetag.pageInit({ blockingFuseIds: ['23174194642'] });
    //   });
    //   fusetag.que.push(function () {
    //     fusetag.registerZone('bookmark_vrec');
    //   });
    // }
  }

  async authcall() {
    await this.cache.getAuthUser()
      .then(async data => {
        let { given_name, picture, userName, login } = data;
        this.userName = given_name;
        this.userId = userName; this.isAdmin
        this.profilePicture = picture;
        this.isLogin = login;
        this.isLoading = false;
        await this.userService.getUser(false).then(data => {
          this.memberskelload = false;
          this.userName = data.first_name;
          this.profilePicture = data.pictureUrl === undefined ? picture : data.pictureUrl;
          this.memberId = data.member_id;
          this.isPrime = data.isPrime;
          // The section below is commented out because Publift ads need to be removed.
          // if(this.isPrime || (!this.isPrime && !this.isMobile)){
          //   this.helperService.addGlobalStyle('.publift-widget-23174194645-container,.publift-widget-23196941527-container { display: none !important}');
          // }
          this.userEmail = data.email;
          this.subscriptionID = data.subscriptionId
          data.userType === 'admin' ? this.isAdmin = true : this.isAdmin = false;
          this.spinner.hide()
        })
        await this.get_payment.getUserData(userName, given_name)
      })

  }
  async logout() {
    try {
      await await Auth.signOut()
      this.userService.userData = undefined;
      this.userService.isFirstCall = true;
      this.mixpanel.actions.reset()
      this.zone.run(() => this.router.navigate(['/login']));
    } catch (error) {
      if (error.code === 'NotAuthorizedException') {
        console.error('Access Token has been revoked. Please log in again.');
        localStorage.clear();
        // Optionally redirect to login or show a message to the user
        this.router.navigate(['/login']);
      } else {
        console.error('Error signing out:', error);
      }
    }
  }
  ngOnDestroy() {
    // The section below is commented out because Publift ads need to be removed.
    // this.helperService.removeGlobalStyle();
    let data = undefined;
    this.adminservice.shareUserData(data);
    // Unsubscribe to prevent memory leaks
    if (this.subscription1) {
      this.subscription1.unsubscribe();
    }
    if (this.subscription2) {
      this.subscription2.unsubscribe();
    }
  }
  onMouseOverAvatar() {
    document.getElementById('user-menu').style.display = 'block';
  }
  onMouseLeaveAvatar() {
    document.getElementById('user-menu').style.display = 'none';
  }
  onMenuClose() {
    document.getElementById('mobile-menu').style.display = 'none';
  }
  Takemetoprime() {
    if (this.isLogin) {
      this.router.navigate(['/pricing']);
    } else {
      this.router.navigate(['/signup']);
    }
  }
  onMenuOpen() {
    document.getElementById('mobile-menu').style.display = 'block';
    let mobileMenu = gsap.timeline();
    mobileMenu.from(['#mobile-menu'], {
      delay: 0,
      opacity: 0,
      x: -1500,
      duration: 0.8,
      ease: 'power3.outIn',
      stagger: {
        amount: 0.4,
      },
    });
  }
  async unsubscribePrimeSubscription() {
    let data = {
      "subscriptionId": this.subscriptionID,
      "userEmail": this.userEmail
    }
    this.get_payment.primeTableUpdate(data).then(data => {
      this.userService.getUser(true);
      this.showconfirmModal = false;
    }, err => {
      // console.log(err)
    })
  }
  onClickCloseConfirmPopup() {
    this.showconfirmModal = false
  }

  onClickShowConfirmPopup() {
    this.showconfirmModal = true
  }

  hideSkeleton() {
    this.memberskelload = false;
  }

  toTipJar() {
    this.isTipJar = true;
    this.isMyVideo = false;
    this.isBookmark = false;
  }

  toBookmarks() {
    this.isBookmark = true;
    this.isMyVideo = false;
    this.isTipJar = false;
  }

  toMyWindows() {
    this.isMyVideo = true;
    this.isBookmark = false;
    this.isTipJar = false;
  }
}
